// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Програма партії» (Party Programme, ключ `prg`, група `party-and-group`). */
export const partyProgrammeManifest: IModuleManifest = {
  key: 'prg',
  group: 'party-and-group',
  slug: 'party-programme',
  prefix: 'PRG',
  name: { en: 'Party Programme', uk: 'Програма партії' },
  entities: [
    { key: 'prg', slug: 'prg', name: { en: 'Party Programme', uk: 'Програма партії' }, main: true },
    { key: 'pos', slug: 'pos', name: { en: 'Positions', uk: 'Позиції' }, main: false },
    { key: 'chapter_goal', slug: 'chapter-goal', name: { en: 'Chapter Goals', uk: 'Цілі' }, main: false },
    { key: 'chapter_evidence', slug: 'chapter-evidence', name: { en: 'Chapter Evidences', uk: 'Докази' }, main: false },
    { key: 'chapter_revision', slug: 'chapter-revision', name: { en: 'Chapter Revisions', uk: 'Редакції' }, main: false },
  ],
  loadState: () => import('./state/partyProgrammeSlice').then((m) => m.partyProgrammeSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
